import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlComponent } from "../../control.component";
import { PassAlertFailControl } from "../pass-alert-fail-control.model";
import { PassAlertFailControlConfigItem } from "../config/pass-alert-fail-control-config-item.model";
import { PassAlertFailFieldItemValue } from "./pass-alert-fail-control-item-value.model";
import { PassAlertFailFieldNode } from "./pass-alert-fail-control-node.model";
import { PassAlertFailFieldNodeFormProvider } from "./pass-alert-fail-control-node-value-provider.interface";
import { isDefined, isString } from "ionic-angular/util/util";
import { PassAlertFailFieldValue } from "./pass-alert-fail-control-value.interface";

@Component({
    selector: "passalertfail",
    template: `
        <passalertfail-node
            *ngFor="let node of itemNodes"
            [node]="node"
            (onChange)="onNodeChange($event)"
        ></passalertfail-node>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PassAlertFailControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => PassAlertFailControlComponent), multi: true}
    ]
})
export class PassAlertFailControlComponent extends ControlComponent implements PassAlertFailFieldNodeFormProvider {
    @Input() definition: PassAlertFailControl;
    @Input() formControl: FormControl;
    @Output() changes: EventEmitter<any> = new EventEmitter();
    @Input("value") _value: PassAlertFailFieldValue = {} as PassAlertFailFieldValue;

    itemNodes: Array<PassAlertFailFieldNode> = [];

    constructor(
        protected elemRef: ElementRef
    ) {
        super(elemRef);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.itemNodes = this.itemsToNodes(this.definition.config.items || []);
        this.prepareValues(this.itemNodes);
    }

    /**
     * Converts a tree of PassAlertFailControlConfigItem to a tree of PassAlertFailFieldNode
     * @param items
     * @returns {Array<PassAlertFailFieldNode>}
     */
    itemsToNodes(items: Array<PassAlertFailControlConfigItem>): Array<PassAlertFailFieldNode> {
        return items.map(option => new PassAlertFailFieldNode(option, this));
    }

    /**
     * Ensures there is a PassAlertFailFieldItemValue for every PassAlertFailControlConfigItem in the tree
     * @param items
     */
    prepareValues(items: Array<PassAlertFailControlConfigItem>): void {

        items.forEach(item => {

            if (isDefined(this._value[item.id])) {
                return;
            }
            this.updateValue(this.getDefaultValueForItem(item));

            this.prepareValues(item.children);
        });
    }

    /**
     * Handle the node change event
     * @param item
     */
    onNodeChange(item: PassAlertFailFieldItemValue): void {
        this.updateValue(item);
    }

    /**
     * @inheritDoc
     * @param value
     */
    updateValue(value: PassAlertFailFieldItemValue): void {
        super.updateValue({
            ...this._value,
            [value.optionId]: value
        });
    }

    /**
     * Returns the default values for PassAlertFailFieldItemValue
     * @param item
     * @returns {PassAlertFailFieldItemValue}
     */
    getDefaultValueForItem(item: PassAlertFailControlConfigItem): PassAlertFailFieldItemValue {

        switch (item.type) {
            // @todo other item types

            default: {
                return new PassAlertFailFieldItemValue({
                    result: "1",
                    optionId: item.id
                });
            }
        }
    }

    /**
     * Returns a FormControl instance for storing the value of a PassAlertFailFieldItemValue
     * @param item
     * @returns {FormControl}
     */
    getFormControl(item: PassAlertFailControlConfigItem): FormControl {

        let value: PassAlertFailFieldItemValue;

        value = Object
            .keys(this.value)
            .map(key => this.value[key])
            .find(i => i.optionId === item.id);

        if (!value) {
            value = this.getDefaultValueForItem(item);
        }

        return new FormControl(value);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control.component.ts